import { 
  HiOutlineViewGrid, 
  HiOutlineDatabase,
  HiOutlineServer,
  HiOutlineChartBar,
  HiOutlineClock
} from 'react-icons/hi';
import { SERIES_LIST } from '../model/UnitSeries';

export const sidebarConfig = {
  title: 'Chowa Dashboard',
  menuItems: [
    {
      path: 'main',
      name: 'Dashboard',
      icon: HiOutlineViewGrid
    },
    {
      path: 'time-monitoring',
      name: '時間監視',
      icon: HiOutlineClock,
      subItems: SERIES_LIST.map(series => ({
        path: series.key.toLowerCase(),
        name: series.name,
        icon: HiOutlineChartBar,
        series: series.key
      }))
    },
    {
      path: 'tms',  // TMSメインメニュー
      name: 'TMS',
      icon: HiOutlineServer,
      subItems: [   // サブメニューの配列
        {
          path: 'old_tms',
          name: 'TMS#000(旧)',
          icon: HiOutlineDatabase
        },
        {
          path: 'tms000',
          name: 'TMS#000(新)',
          icon: HiOutlineDatabase
        }
      ]
    },
    // {
    //   path: '/download',  // ルートパスから始まるパスを指定
    //   name: 'ダウンロード',
    //   icon: HiOutlineDownload,
    //   external: true  // 外部リンクとしてマーク
    // }
  ]
};
